import Agency from './Agency';
import Invoice from './billing/invoice';
import Customer from './customer';
import Site from './site';
import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import { LocalDate } from '../utils/local-date';
import type SiteInvoicesItem from './site-invoices-item';

@JsonApiResource({
  type: 'site-invoice',
})
export default class SiteInvoice extends BaseEntity {
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) })
  public startDate: LocalDate;

  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) })
  public endDate: LocalDate;

  @JsonApiProperty({ type: 'object' })
  public serviceTypesTotals: Record<string, number>;

  @JsonApiRelationship('invoice')
  public invoice: Invoice;

  @JsonApiRelationship('customer')
  public customer: Customer;

  @JsonApiRelationship('agency')
  public agency: Agency;

  @JsonApiRelationship('site')
  public site: Site;

  @JsonApiRelationship('site-invoices-item')
  public siteInvoicesItems: SiteInvoicesItem[];

  @JsonApiProperty({ resolver: Number })
  public totalPrice: number = 0.0;

  constructor(
    id?: BaseEntity['id'],
    startDate: LocalDate = new LocalDate().startOf('month'),
    endDate: LocalDate = new LocalDate().endOf('month'),
    public status: string = '',
    public state: string = '',
    public county: string = '',
    totalPrice: number = 0.0,
    serviceTypesTotals: SiteInvoice['serviceTypesTotals'] = {},
    customerInvoice: SiteInvoice['invoice'] = new Invoice(),
    agency: SiteInvoice['agency'] = new Agency(),
    customer: SiteInvoice['customer'] = new Customer(),
    site: SiteInvoice['site'] = new Site(),
    siteInvoicesItems: SiteInvoice['siteInvoicesItems'] = []
  ) {
    super();
    this.id = id;
    this.startDate = startDate;
    this.endDate = endDate;
    this.invoice = customerInvoice;
    this.agency = agency;
    this.customer = customer;
    this.site = site;
    this.serviceTypesTotals = serviceTypesTotals;
    this.siteInvoicesItems = siteInvoicesItems;
    this.totalPrice = totalPrice;
  }
}
